import React from 'react';
import {
  Box,
  LinearProgress,
  Typography,
  useTheme
} from '@mui/material';

const ProgressBar = ({
  currentPage = 1,
  totalPages = 1,
  scrollPosition = 0,
  documentHeight = 0,
  documentType = 'text'
}) => {
  const theme = useTheme();

  // Calculate progress based on page position
  const getProgress = () => {
    return totalPages > 0 ? (currentPage / totalPages) * 100 : 0;
  };

  const progress = getProgress();

  const getProgressColor = () => {
    if (progress < 25) return 'error';
    if (progress < 50) return 'warning';
    if (progress < 75) return 'info';
    return 'success';
  };

  const getProgressText = () => {
    return `Page ${currentPage} of ${totalPages}`;
  };

  return (
    <Box
      sx={{
        px: 2,
        py: 1,
        backgroundColor: theme.palette.background.paper,
        borderBottom: `1px solid ${theme.palette.divider}`
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 0.5 }}>
        <Typography variant="caption" color="text.secondary">
          Reading Progress
        </Typography>
        <Typography variant="caption" color="text.secondary">
          {getProgressText()}
        </Typography>
      </Box>
      
      <LinearProgress
        variant="determinate"
        value={progress}
        color={getProgressColor()}
        sx={{
          height: 6,
          borderRadius: 3,
          backgroundColor: theme.palette.grey[200],
          '& .MuiLinearProgress-bar': {
            borderRadius: 3,
            transition: 'transform 0.3s ease-in-out'
          }
        }}
      />
      
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 0.5 }}>
        <Typography variant="caption" color="text.secondary">
          Start
        </Typography>
        <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 'bold' }}>
          {Math.round(progress)}%
        </Typography>
        <Typography variant="caption" color="text.secondary">
          End
        </Typography>
      </Box>
    </Box>
  );
};

export default ProgressBar;
